import { render, staticRenderFns } from "./shelves.vue?vue&type=template&id=1c247d48&scoped=true&"
import script from "./shelves.vue?vue&type=script&lang=js&"
export * from "./shelves.vue?vue&type=script&lang=js&"
import style0 from "./shelves.vue?vue&type=style&index=0&id=1c247d48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c247d48",
  null
  
)

export default component.exports